export default "__VITE_ASSET__LvHJeHcr__"